import { render, staticRenderFns } from "./ShouninRouteLocalHeader.vue?vue&type=template&id=e5dc6ac6&scoped=true&"
import script from "./ShouninRouteLocalHeader.vue?vue&type=script&lang=ts&"
export * from "./ShouninRouteLocalHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ShouninRouteLocalHeader.vue?vue&type=style&index=0&id=e5dc6ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5dc6ac6",
  null
  
)

export default component.exports